<template>
    <div :class="['table-wrapper', {'sticky': isSticky}]" :ref="containerId">
        <table class="table even-odd">
            <colgroup class="colgroup">
                <col v-for="column in fixedColumnsList"
                     :key="column.field"
                     :class="'colgroup_' + column.field"
                     :span="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'">

                <col v-for="column in data.columns"
                     v-if="isShowColumn(column)"
                     :key="column.field"
                     :class="'colgroup_' + column.field"
                     :span="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'">
            </colgroup>

            <thead class="thead">
                <tr class="tr">
                    <!-- Fixed columns section start -->
                    <th class="th fixedColumn"
                         v-for="(column, columnIndex) in fixedColumnsList"
                         :key="column.field + '_fixed'"
                         v-on:mouseenter="onThHover(column.field, true)"
                         v-on:mouseleave="onThHover(column.field, false)"
                         :ref="'th_fixed_' + column.field"
                         v-bind:class="{'last-child': columnIndex == (fixedColumnsList.length - 1)}"
                         :colspan="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'"
                         :rowspan="(dateComparisonFieldsStatus[column.field]) ? '1' : '2'"
                    >
                        <div class="thWrapper">
                            <div class="column-header-wrapper" :style="{'min-width': column.width}">
                                <span class="pin-fixed-column fixed" @click="makeColumnFixed(column)"></span>
                                <span @click="applySorting(column.field)">{{column.label}} {{column.sign}}</span>
                                <span class="sorting" v-visible="column.sort && (isColumnHovered(column.field) || getSortableElementDirection(column) !== false)">
                                    <i class="sorting-top"
                                       @click.exact="applySorting(column)"
                                       @click.ctrl="applyMultipleSorting(column)"
                                       v-bind:class="{'active': (getSortableElementDirection(column) == 'ASC')}"
                                       v-show="(!getSortableElementDirection(column) || getSortableElementDirection(column) == 'ASC')"
                                    ></i>

                                   <i class="sorting-bottom"
                                      @click.exact="applySorting(column)"
                                      @click.ctrl="applyMultipleSorting(column)"
                                      v-bind:class="{'active': (getSortableElementDirection(column) == 'DESC')}"
                                      v-show="(!getSortableElementDirection(column) || getSortableElementDirection(column) == 'DESC')"
                                   ></i>
                                </span>
                            </div>
                            <div v-if="isDatesComparisonEnabled && (data.subColumns && data.subColumns[column.field] && data.subColumns[column.field].length > 1)"
                                 class="column-dates-comparison-wrapper"
                                 @click="showDatesComparisonData(column.field)">
                                <i :class="{'active': dateComparisonFieldsStatus[column.field]}"></i>
                            </div>
                        </div>
                    </th>
                    <!-- Fixed columns section end -->

                    <!-- Regular columns section start-->
                    <th class="th"
                         v-for="(column, key) in data.columns"
                         v-if="isShowColumn(column)"
                         :key="column.field"
                         v-on:mouseenter="onThHover(column.field, true)"
                         v-on:mouseleave="onThHover(column.field, false)"
                        :colspan="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'"
                        :rowspan="(dateComparisonFieldsStatus[column.field]) ? '1' : '2'">

                        <div class="thWrapper">
                            <div class="column-header-wrapper" :style="{'min-width': column.width}">
                                <span v-visible="((isColumnHovered(column.field)) && column.canBeFixed)"
                                      class="pin-fixed-column"
                                      @click="makeColumnFixed(column)">
                                </span>

                                <span @click="applySorting(column)">{{column.label}}</span>
                                <span class="sorting" v-visible="column.sort && (isColumnHovered(column.field) || getSortableElementDirection(column) !== false)">
                                    <i class="sorting-top"
                                       @click.exact="applySorting(column)"
                                       @click.ctrl="applyMultipleSorting(column)"
                                       v-bind:class="{'active': (getSortableElementDirection(column) == 'ASC')}"
                                       v-show="(!getSortableElementDirection(column) || getSortableElementDirection(column) == 'ASC')"
                                    ></i>

                                   <i class="sorting-bottom"
                                      @click.exact="applySorting(column)"
                                      @click.ctrl="applyMultipleSorting(column)"
                                      v-bind:class="{'active': (getSortableElementDirection(column) == 'DESC')}"
                                      v-show="(!getSortableElementDirection(column) || getSortableElementDirection(column) == 'DESC')"
                                   ></i>
                                </span>
                            </div>
                            <div v-if="isDatesComparisonEnabled && (data.subColumns && data.subColumns[column.field] && data.subColumns[column.field].length > 1)"
                                 class="column-dates-comparison-wrapper"
                                 @click="showDatesComparisonData(column.field)">
                                <i :class="{'active': dateComparisonFieldsStatus[column.field]}"></i>
                            </div>
                        </div>

                    </th>
                    <!-- Regular columns section end-->
                </tr>
                <tr class="tr" v-if="isDatesComparisonEnabled">
                    <template
                        v-for="(column, columnIndex) in fixedColumnsList"
                        v-on:mouseenter="onThHover(column.field, true)"
                        v-on:mouseleave="onThHover(column.field, false)"
                        :colspan="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'">

                        <!-- Regular subcolumns section start-->
                        <template v-if="data.subColumns && isArray(data.subColumns[column.field])">
                            <th class="th fixedColumn subColumns fixed" v-for="(label, labelIndex) in data.subColumns[column.field]"
                                v-if="(dateComparisonFieldsStatus[column.field])"
                                :ref="'th_fixed_subColumns_' + column.field"
                                v-bind:class="{'last-child': ((columnIndex == fixedColumnsList.length -1) && (labelIndex == (data.subColumns[column.field].length - 1)))}">
                                <div class="column-header-wrapper subHeader">
                                    <span>{{label}}</span>
                                </div>
                            </th>
                        </template>
                        <!-- Regular subcolumns section end -->
                    </template>

                    <template
                        v-for="(column, key) in data.columns"
                        v-if="(data.subColumns && data.subColumns[column.field] && data.subColumns[column.field].length > 1 && dateComparisonFieldsStatus[column.field]) && isShowColumn(column)"
                        v-on:mouseenter="onThHover(column.field, true)"
                        v-on:mouseleave="onThHover(column.field, false)"
                        :colspan="(dateComparisonFieldsStatus[column.field]) ? '4' : '1'">
                            <!-- Regular subcolumns section start-->
                            <template v-if="data.subColumns && isArray(data.subColumns[column.field])">
                                <th class="th subColumns" v-for="label in data.subColumns[column.field]">
                                    <div class="column-header-wrapper subHeader">
                                        <span>{{label}}</span>
                                    </div>
                                </th>
                            </template>
                            <!-- Regular subcolumns section end -->
                    </template>
                </tr>
            </thead>
            <tbody class="tbody">
                <tr class="tr" v-for="(row, rowIndex) in data.rows" :key="rowIndex">

                    <template v-for="(column, columnIndex) in fixedColumnsList">
                        <template v-if="isDatesComparisonEnabled && data.subColumns && isArray(data.subColumns[column.field])">
                            <template v-if="dateComparisonFieldsStatus[column.field]">
                                <td class="td fixedColumn"
                                    v-for="item in row[column.field]"
                                    :ref="'td_fixed_' + column.field"
                                    v-bind:class="[column.field, {'last-child': columnIndex == (fixedColumnsList.length - 1)}]">
                                    <div>{{item}}</div>
                                </td>
                            </template>
                            <template v-else>
                                <td class="td fixedColumn"
                                    :ref="'td_fixed_' + column.field"
                                    v-bind:class="[column.field, {'last-child': columnIndex == (fixedColumnsList.length - 1)}]">
                                    <div>{{row[column.field][0]}}</div>
                                </td>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="isArray(row[column.field])">
                                <CCTableArrayView :cellValue="row[column.field]" :classes="column.classes"></CCTableArrayView>
                            </template>
                            <template v-else-if="fieldNameDropDown.length && fieldNameDropDown.includes(column.field)">
                                <CCTableDropDownView :cellValue="row[column.field]"
                                                     :dropDownMenuUrls="dropDownMenuUrls"
                                                     :row="row"
                                                     :column="column"
                                                     :namespace="namespace">
                                </CCTableDropDownView>
                            </template>
                            <template v-else>
                                <td class="td fixedColumn"
                                    :ref="'td_fixed_' + column.field"
                                    v-bind:class="[column.field, {'last-child': columnIndex == (fixedColumnsList.length - 1)}]">

                                    <div>{{row[column.field] | formatValue(column.sign)}}</div>

                                </td>
                            </template>
                        </template>
                    </template>

                    <template v-for="column in data.columns"
                         v-if="isShowColumn(column)"
                         :class="column.field"
                    >
                        <template v-if="isDatesComparisonEnabled && data.subColumns && isArray(data.subColumns[column.field])">
                            <template v-if="dateComparisonFieldsStatus[column.field]">
                                <td class="td" v-for="item in row[column.field]">
                                    <div>{{item | formatValue(column.sign)}}</div>
                                </td>
                            </template>
                            <template v-else>
                                <td class="td">
                                    <div>{{row[column.field][0] | formatValue(column.sign)}}</div>
                                </td>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="isArray(row[column.field])">
                                <CCTableArrayView :cellValue="row[column.field]"></CCTableArrayView>
                            </template>
                            <template v-else-if="fieldNameDropDown.length && fieldNameDropDown.includes(column.field)">
                                <CCTableDropDownView :cellValue="row[column.field]"
                                                     :dropDownMenuUrls="dropDownMenuUrls"
                                                     :row="row"
                                                     :column="column"
                                                     :namespace="namespace">
                                </CCTableDropDownView>
                            </template>
                            <template v-else>
                                <td class="td" v-bind:class="[column.classes, getCellMetaInfoClass(rowIndex, column.field)]">
                                    <div>{{row[column.field] | formatValue(column.sign)}}</div>
                                </td>
                            </template>
                        </template>
                    </template>

                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import hoverTableMixin from '@/components/reports/mixins/hoverTableMixin';
    import _lodash from 'lodash';
    import CCTableArrayView from '@/components/common/table/cellViewTypesHandlers/CCTableArrayView';
    import CCTableDropDownView from "@/components/common/table/cellViewTypesHandlers/CCTableDropDownView";

    export default {
        name: "cc-table",
        props: {
            data: {
                type: Object,
                required: true
            },
            sortColumnsList: {
                type: Array,
                required: true
            },
            fieldNameDropDown: {
                type: Array,
                required: false,
                default: function() { return [];}
            },
            dropDownMenuUrls :{
                type: Array,
                required: false
            },
            namespace: {
                type: String,
                required: true
            },
            isDatesComparisonEnabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        components: {
            CCTableArrayView,
            CCTableDropDownView
        },
        mixins: [
            hoverTableMixin
        ],
        data() {
            return {
                fixedColumnsList: [],
                containerId: this._uid + '_container_id',
                isSticky: false,
                showFixedColumns: false,
                dateComparisonFieldsStatus: {}
            }
        },
        mounted() {
            let container = this.$refs[this.containerId];
            container.addEventListener('scroll', this.handleScroll, {'passive': true, 'capture': true});
        },
        beforeDestroy() {
            let container = this.$refs[this.containerId];
            container.removeEventListener('scroll', this.handleScroll);
        },
        updated: function(){
            if (this.fixedColumnsList.length)
            {
                this.showFixedColumns = true;
            }
            else
            {
                this.showFixedColumns = false;
            }
        },
        filters: {
            formatValue: function(value, sign)
            {
                if (sign && sign != '$' && value != 'N/A')
                {
                    return value + sign;
                }
                else
                {
                    return value;
                }
            },
        },
        methods: {
            getCellMetaInfoClass(rowIndex, field, arrayIndex = null) {
                let meta = this.getCellMetaInfo(rowIndex, field, arrayIndex);
                if( meta && meta.class ) {
                    return meta.class;
                }
                return null;
            },

            getCellMetaInfo(rowIndex, field, arrayIndex = null) {
                let meta = this.data.cellMetaInfo;
                if( meta && meta[rowIndex] && meta[rowIndex][field] ) {
                    if( arrayIndex !== null ) {
                        if( meta[rowIndex][field][arrayIndex] ) {
                            return meta[rowIndex][field][arrayIndex];
                        }
                    } else {
                        return meta[rowIndex][field];
                    }
                }

                return null;
            },
            
            showDatesComparisonData(field){
                if (this.dateComparisonFieldsStatus[field] === undefined)
                {
                    this.dateComparisonFieldsStatus[field] = true;
                }
                else
                {
                    // this.$set[this.dateComparisonFieldsStatus, field, !this.dateComparisonFieldsStatus[field]];
                    this.dateComparisonFieldsStatus[field] = !this.dateComparisonFieldsStatus[field];
                }

            },
            isArray(value){
                return _lodash.isArray(value);
            },
            handleScroll () {
                let element = this.$refs[this.containerId];

                if (element.scrollTop > 0)
                {
                    this.isSticky = true;
                }
                else
                {
                    this.isSticky = false;
                }

                if (element.scrollLeft > 0)
                {
                    let offset = element.scrollLeft;
                    if (this.fixedColumnsList.length)
                    {
                        for (let item of this.fixedColumnsList)
                        {
                            this.$refs['th_fixed_' + item.field][0].style.transform = 'translate(' + offset + 'px, 0px)';
                            this.$refs['td_fixed_' + item.field].map(item => item.style.transform = 'translate(' + offset + 'px, 0px)');

                            if (this.$refs['th_fixed_subColumns_' + item.field])
                            {
                                this.$refs['th_fixed_subColumns_' + item.field].map(item => item.style.transform = 'translate(' + offset + 'px, 0px)');
                            }
                        }
                    }
                }
                else
                {
                    if (this.fixedColumnsList.length)
                    {
                        for (let item of this.fixedColumnsList)
                        {
                            this.$refs['th_fixed_' + item.field][0].style.transform = 'translate(0px, 0px)';
                            this.$refs['td_fixed_' + item.field].map(item => item.style.transform = 'translate(0px, 0px)');

                            if (this.$refs['th_fixed_subColumns_' + item.field])
                            {
                                this.$refs['th_fixed_subColumns_' + item.field].map(item => item.style.transform = 'translate(0px, 0px)');
                            }
                        }
                    }
                }
            },
            calculatePositionForNewFixedColumn: function(item){
                let that = this;
                let element = this.$refs[this.containerId];

                if (element.scrollLeft > 0)
                {
                    let offset = element.scrollLeft;

                    if (this.fixedColumnsList.length)
                    {
                        this.$nextTick(function(){
                            that.$refs['th_fixed_' + item.field][0].style.transform = 'translate(' + offset + 'px, 0px)';

                            if (this.$refs['th_fixed_subColumns_' + item.field])
                            {
                                that.$refs['th_fixed_subColumns_' + item.field][0].style.transform = 'translate(' + offset + 'px, 0px)';
                            }

                            that.$refs['td_fixed_' + item.field].map(item => item.style.transform = 'translate(' + offset + 'px, 0px)');
                        });
                    }
                }
            },
            isShowColumn: function(column)
            {
                if (this.isColumnFixed(column) !== false)
                {
                    return false;
                }

                return true;
            },
            isColumnFixed: function(column)
            {
                let key = this.fixedColumnsList.findIndex(function(item){
                    return (item.field == column.field)
                });

                if (key !== -1)
                {
                    return key;
                }

                return false;
            },
            makeColumnFixed: function(column)
            {
                if (this.fixedColumnsList.length)
                {
                    let itemIndex = this.isColumnFixed(column);

                    if (itemIndex !== false)
                    {
                        this.removeHovering(column.field);
                        this.fixedColumnsList.splice(itemIndex, 1);
                    }
                    else
                    {
                        this.fixedColumnsList.push(column);
                        this.calculatePositionForNewFixedColumn(column);
                    }
                }
                else
                {
                    this.fixedColumnsList.push(column);
                    this.calculatePositionForNewFixedColumn(column);
                }
            },
            getSortableElementDirection: function(column)
            {
                let key = this.sortColumnsList.findIndex(function(item)
                {
                    return (item.field == column.field)
                });

                if (key != -1)
                {
                    return this.sortColumnsList[key]['direction'];
                }

                return false;
            },
            applySorting: function(column){
                this.$emit('sortColumn', column);
            },
            applyMultipleSorting: function(column){
                this.$emit('sortMultipleColumn', column);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .fixedColumn {
        z-index: 2;
        background-color: #fff;
    }

    .pin-fixed-column {
        display: block;
    }

    .hovered {
        /*background: #f5f5f5;*/

        background: #f6fafe;
    }

    .column-header-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .table-wrapper {
        background-color: #fff;
        width: 100%;
        height: 70vh;
        overflow-x: scroll;

        .table > .thead > .tr > .th.subColumns {
            min-width: 85px;
        }

        &.sticky {
            .table > .thead > .tr > .th {
                top: 0px;
                position: sticky;
            }

            .table > .thead > .tr > .th.subColumns {
                top: 39px;
                position: sticky;

                &.fixed {
                    z-index: 3;
                }
            }
        }

        &.fixedTable {
            width: min-content;
            overflow-x: visible;
            border-right: 1px solid $border-color;
        }

        &::-webkit-scrollbar {
            width: 8px;
            border-radius: 8px;
            height: 8px;
            background-color: #9b9b9b;
        }

        &::-webkit-scrollbar-track {
            border-radius: 8px;
            background-color: #d8d8d8;
        }

        &::-webkit-scrollbar-thumb
        {
            border-radius: 8px;
            -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,.3);
            background-color: #9b9b9b;
        }

        .table {
            //display: table;
            border-collapse: separate;
            border-spacing: 0px;

            .thead {
                //display: table-header-group;

                .tr {
                    //display: table-row;

                    .th {
                        height: 39px;
                        vertical-align: middle;
                        cursor: pointer;
                        border-right: 1px solid #d7d7d7;
                        border-bottom: 1px solid #d7d7d7;
                        padding: 0;
                        background: linear-gradient(180deg,#fbfbfb 5%,#ededed);
                        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fbfbfb",endColorstr="#ededed",GradientType=0);
                        background-repeat: no-repeat;

                        &.last-child {
                            border-right: 2px solid #d7d7d7;
                        }

                        &.dateComparison {

                        }

                        & > div.thWrapper {
                            //display: grid;
                            //grid-template-rows: 1fr;
                            //height: 100%;

                            &.hasSubColumns {
                                //grid-template-rows: 1fr 1fr;
                            }
                        }
                    }

                    &:first-child {
                        .th {
                            border-top: 1px solid #d7d7d7;
                        }
                    }
                }
            }

            .tbody {
                //display: table-row-group;

                .tr {
                    //display: table-row;

                    .td {
                        //display: table-cell;
                        vertical-align: middle;
                        border-right: 1px solid #d7d7d7;
                        /*border-bottom: 1px solid #d7d7d7;*/
                        padding: 2px;

                        &.last-child {
                            border-right: 2px solid #d7d7d7;
                        }

                        & > div {

                            & > .tdHasSubColumns {
                                //display: grid;
                                //grid-template-columns: 1fr 1fr 1fr 1fr;

                                & > div {
                                    //height: 100%;
                                    border-right: 1px solid $border-color;
                                    //display: grid;
                                }
                            }
                        }

                        & + .campaign-column {
                            & > div {
                                width: max-content;
                            }
                        }
                    }

                    &:hover {
                        background: #f5f5f5;
                    }
                }
            }
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/common/table/CCTable.vue